import type { NotificationFormType, Notifications } from '@/notificationForms'

import { useMemo } from 'react'

import { form } from '../../../../formState'

export function useMessageSettings(notification: NotificationFormType) {
  // includeMessageUnsubscriptionInstructions
  const includeMessageUnsubscriptionInstructions = form.useFormField(
    'includeMessageUnsubscriptionInstructions',
  ).field.value

  // // includeMessageTrackingLink
  const includeMessageTrackingLink = form.useFormField('includeMessageTrackingLink').field.value

  // // templateDefaultLimits
  const templateDefaultLimits = form.useFormField('templateDefaultLimits').field.value

  // // templateCustomLimits
  const templateCustomLimits = form.useFormField('templateCustomLimits').field.value

  const notificationType = useMemo(() => `${notification}Settings` as Notifications, [notification])
  const notificationLimits = useMemo(() => {
    return {
      ...templateDefaultLimits,
      ...templateCustomLimits,
    } as uui.domain.client.rm.NotificationTemplateLimits
  }, [templateDefaultLimits, templateCustomLimits])

  return {
    notificationType,
    notificationLimits,
    includeMessageTrackingLink,
    includeMessageUnsubscriptionInstructions,
  }
}
